var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7907 13.7191V17.2322H21.2093V13.7191H21.339C22.2564 13.7191 23 12.9897 23 12.0899V11.9749C23 8.54825 20.0362 5.8412 16.5517 6.08534C15.695 6.14537 14.8388 5.96281 14.0848 5.55938L12.7165 4.82729C10.6752 3.73505 8.21051 3.7237 6.15877 4.79709L4.65663 5.58295C2.4059 6.76044 1 9.05893 1 11.5611V11.9626C1 12.9327 1.80172 13.7191 2.7907 13.7191ZM6.88107 6.12557C8.47687 5.29071 10.3938 5.29953 11.9815 6.14906L13.3498 6.88115C14.3619 7.42266 15.5112 7.66769 16.6611 7.58713C19.257 7.40524 21.4651 9.42202 21.4651 11.9749V12.0899C21.4651 12.1582 21.4087 12.2135 21.339 12.2135H21.2093V10.9589C21.2093 10.4045 20.7512 9.95512 20.186 9.95512H3.81395C3.24882 9.95512 2.7907 10.4045 2.7907 10.9589V12.2135C2.64942 12.2135 2.53488 12.1012 2.53488 11.9626V11.5611C2.53488 9.61497 3.62836 7.82726 5.37893 6.91143L6.88107 6.12557ZM9.95349 14.9738C9.95349 14.4195 10.4116 13.9701 10.9767 13.9701H13.0233C13.5884 13.9701 14.0465 14.4195 14.0465 14.9738C14.0465 15.5282 13.5884 15.9776 13.0233 15.9776H10.9767C10.4116 15.9776 9.95349 15.5282 9.95349 14.9738Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2092 18.7378H2.79065V20.9963C2.79065 21.5506 3.24878 22 3.8139 22H20.186C20.7512 22 21.2092 21.5506 21.2092 20.9963V18.7378Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurse1);
export default __webpack_public_path__ + "static/media/purse-1.9141af6bfaf5a7f81a2d968d7562ac81.svg";
export { ForwardRef as ReactComponent };